import React from 'react';

const FrontPageWhyHire = () => (
  <section className="front-page--section">
    <h1 className="front-page--title front-page--title-divider">Why hire me?</h1>
    <div className="front-page--section-block-container">
      <div className="front-page--section-block front-page--section-block-half">
        <h2 className="front-page--subtitle">Communication</h2>
        <p>
          Communication is an absolute necessity. I take the time to understand what you want to
          achieve and I work with you to ensure I deliver the solution you need.
        </p>
      </div>
      <div className="front-page--section-block front-page--section-block-half">
        <h2 className="front-page--subtitle">Competence</h2>
        <p>
          I have spent many years in both private industry and the public sector. I leverage my
          years of experience to efficiently implement solutions using proven technologies and
          modern techniques.
        </p>
      </div>
      <div className="front-page--section-block front-page--section-block-half">
        <h2 className="front-page--subtitle">Honesty</h2>
        <p>
          I am truthful about what I know and what I don&apos;t know, and what I can and can&apos;t
          do. If you ask me a question and I don&apos;t know the answer I will tell you I don&apos;t
          know the answer. But I will do the research and find the right answer, I won&apos;t guess
          and I won&apos;t pretend.
        </p>
      </div>
      <div className="front-page--section-block front-page--section-block-half">
        <h2 className="front-page--subtitle">Passion</h2>
        <p>
          I genuinely love what I do. Crafting a software product that is well designed, properly
          architected and solidly coded is extremely satisfying. I am excited to help you turn your
          ideas into reality.
        </p>
      </div>
    </div>
  </section>
);

export default FrontPageWhyHire;



// WEBPACK FOOTER //
// ./src/components/FrontPageWhyHire.js